import { Modals } from "../components/Modals";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { useAppDispatch } from "../store/store";
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import { showMessage } from "../reducers/msgReducer";
import {
  useState,
  useRef,
  useEffect,
  useCallback
} from "react";
import {
  initialFabricacion,
  propsFabricacion,
  tablePaginationRs,
} from "../utils/formsInitialsStates";
import {
  getFabricacion,
  getFabricaciones,
  savetFabricacion,
} from "../services/fabricaServices";
import { RegistroFabriForm } from "../components/forms-modals/RegistroFabriForm";
import { Table } from "../components/table-pagination-sorting/components/Table";
import NestedTable from "../components/NestedTable"




export const RegistroFabrica = () => {
  const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();


  const [data, setData] = useState({ count: 0 } as {
    count: number;
    rows: Array<{ [key: string]: any }>;
  });
  const [datosFabrica, setDatosFabrica] = useState(
    {} as { on: string; data: propsFabricacion | undefined }
  );

  const FabricaFormRef = useRef<{
    handleClick: () => propsFabricacion;
    resetForm: () => void;
  }>();

  const handelPagination = useCallback(
    (pagination: PaginatingAndSortingProps) => {
      function searchDataFabri(tipe: string, id: number) {
        doneFetchActions(getFabricacion(id)).then((resp: propsFabricacion) => {
          setDatosFabrica({ on: tipe, data: resp });
        });
      }

      doneFetchActions(getFabricaciones(pagination)).then(
        (data: tablePaginationRs) => {
          data.rows = data.rows?.sort((a, b) => (b.estado === true ? 1 : -1)).map((ob) => ({
            ...ob,
            fabricaReceta: (
              <NestedTable data={ob.fabricaReceta} />
            ),

            actions: (
              <>
                <button
                  className="btn"
                  onClick={() => searchDataFabri("edit", ob.id)}
                >
                  <span className="icon-pencil"></span>
                </button>
                {ob.estado ? (
                <span className="icon-unlocked" style={{ color: '#007bff', fontSize: '1rem' }}></span>
                ) : (
                <span className="icon-lock" style={{ color: '#dc3545', fontSize: '1rem' }}></span>
                )},
              </>
            ),
          }));
          setData(data);
        }
      );
    },
    [doneFetchActions]
  );



  const onSaveModal = () => {
    const FabricaValues = FabricaFormRef.current?.handleClick();
    if (FabricaValues) {
      doneFetchActions(savetFabricacion(FabricaValues)).then((resp) => {
        dispatch(
          showMessage({
            isShow: true,
            title: "Fabricación registrada con éxito",
            type: "success",
          })
        );
        handelPagination({} as PaginatingAndSortingProps);
        setDatosFabrica({ on: "", data: initialFabricacion });
        FabricaFormRef.current?.resetForm();
      });
    }
  };
  useEffect(() => {
    handelPagination({} as PaginatingAndSortingProps);
  }, [handelPagination]);

  const onCloseModal = () => {
    FabricaFormRef.current?.resetForm();
    setDatosFabrica({ ...datosFabrica, on: "" });

  };

  const titles = [
    { title: "Fecha Registro", sort: "fecha_registro" },
    { title: "Producción/Lote", name: "fabricaReceta" },
    // { title: "Lote", sort: "lotes" },
    { title: "Comentario", sort: "comentario" },
    { title: "Editar/Estado", name: "actions" },
  ];

  return (
    <div>
      <div className="d-flex justify-content-center pt-4">
        <h4 className="align-self-end">Registros de Fabricación</h4>
      </div>
      <div className="d-flex justify-content-end pb-4">
        <div className="align-self-end">
          <button
            onClick={() => {
              setDatosFabrica({ on: "add", data: undefined });
            }}
            type="button"
            className="btn btn-primary btn-rounded mb-4"
          >
            Registrar Fabricación
          </button>
        </div>
      </div>
      <div></div>
      <Table
        dataTable={{ ...data, titles, limit: 100 }}
        onChange={handelPagination}
      />
      <Modals
        title="Crear Registro de Fabricación"
        onSave={onSaveModal}
        onClose={onCloseModal}
        show={!!datosFabrica.on}
      >
        <RegistroFabriForm
          ref={FabricaFormRef}
          data={datosFabrica.data}
          on={datosFabrica.on}
        />
      </Modals>

    </div>
  );
};
